import Vue from 'vue';
import {
  getInvitation
} from '../../../services/backendService/invitationsService';

 // initial state
 // state 必為模組區域變數，取時需 store.state.auth.user
 // 其他則視 default 內是否有設 namespaced = true 來決定是全域還是區域
 // 區域使用時值需加上 name
const state = {
  reservation: [],
  pagination: {
    current_page: 0,
    per_page: 5
  },
  reservationsTypeList: [],
  reservationTimeList: []
};

 // getters
 const getters = {};

 // actions
const actions = {
  // 取得邀請函
  async getInvitationHandler({ commit }, statusInfo) {
    const data = await getInvitation(statusInfo);
    commit('setInvitation', data);
  }
};

// mutations
const mutations = {
  setInvitation(state, data) {
    Vue.set(state, 'invitation', data.data);
  },
  setReservationsTypeList(state, data) {
    Vue.set(state, 'reservationsTypeList', data['reservation-list']);
  },
  // 重置所有資料
  resetHandler(state) {
    Vue.set(state, 'reservations', []);
    Vue.set(state, 'pagination', {
      current_page: 0,
      per_page: 5
    });
  },
  setReservationTimeList(state, data) {
    Vue.set(state, 'reservationTimeList', data['reservation-time']);
  }
};

 export default {
   namespaced: true,
   state,
   getters,
   actions,
   mutations
 };
